import styles from './styles.module.css';
import { useAuth } from 'context/auth';
import { Icon } from 'common/icon';
import { useIsClient } from 'usehooks-ts';
import { Button } from 'common/new-button';
import { Routes } from 'constants/routes';
import { useRouter } from 'next/router';
import clsx from 'clsx';
import { Tag } from 'components/sidebar-menu/tag';
import { MenuItem } from 'components/sidebar-menu';
import { MenuItemProps } from 'constants/types';

export const CreateAccount = () => {
  const router = useRouter();
  const isClient = useIsClient();
  const { isLoggedIn } = useAuth();

  if (isLoggedIn) {
    return <div />;
  }

  const features = [
    {
      icon: <Icon.Save />,
      label: 'Save your favorites',
    },
    {
      icon: <Icon.Search />,
      label: 'Check casinos',
    },
    {
      icon: <Icon.TrendUp />,
      label: 'Follow RTP changes',
    },
  ];

  return (
    <div className={styles.container}>
      <Tag text="CASINO COMMUNITY" />
      <div className={styles.features}>
        {features.map((feature, index) => (
          <MenuItem key={index} label={feature.label} icon={feature.icon} />
        ))}
      </div>
      {isClient && (
        <div className={styles.wrapper_btn}>
          <Button
            icon={<Icon.UserSecond />}
            text="Create account for free"
            className={clsx(styles.add_slot__btn)}
            onClick={() => router.push(Routes.login)}
          />
        </div>
      )}
    </div>
  );
};
